// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bLHo","title":"styles_title__qAS0U","actions":"styles_actions__1CjKt"};